<section class="dac-sticky-banner" [ngClass]="{ 'is-visible': showFloatingBar }" *ngIf="(serviceList$ | async)?.length">
  <ng-container *ngFor="let item of serviceList$ | async">
    <div class="box">
      <div class="box-content">
        <span class="box-content__heading" [innerHTML]="item.data.heading.iv"></span>
      </div>
      <div class="box-countdown" *ngIf="countdown">
        <span class="box-countdown__group">{{ countdown.days }}</span
        >D<span class="box-countdown__group">{{ countdown.hours }}</span
        >H<span class="box-countdown__group">{{ countdown.minutes }}</span
        >M<span class="box-countdown__group">{{ countdown.seconds }}</span
        >S
      </div>
      <div class="box-btn">
        <a [href]="item.data.registerLink.iv" target="_blank" rel="noopener noreferrer" class="box-btn__layout"
          ><span>{{ item.data.btnText.iv }}</span></a
        ></div
      >
    </div>
  </ng-container>
</section>
